import React, { useEffect, useContext } from 'react'
import ErrorBoundary from '../errorboundry'
import { Form, Message, Grid } from 'semantic-ui-react'
import MerchandiseDuty from './merchandiseDuty'
import SupportingDocs from './supportingDocs'
import PreviciousDocuments from './previciousDocuments'
import SpecialMentions from './specialMentions'
import ProductTag from './productTag'
import MerchForm1 from './merchForm1'
import MerchForm2 from './merchForm2'
import MerchForm3 from './merchForm3'
import MerchForm4 from './merchForm4'
import MerchForm5 from './merchForm5'
import Container from './container'
import InputField from '../../../commonComponents/formComponents/inputField'
import CommercialDescription from './commercialDescription'
import {
  expandLineItem,
  expandAllLineItem,
  saveLineItemFeild,
  updateLineItemFeild,
} from '../../actions'

import { useSelector, useDispatch } from 'react-redux'
import { ShipmentInfoContext } from '../../../context/shipmentInfo.js'
import DropDown from '../../../commonComponents/formComponents/dropDown';
import {addItemsTabWarnings,deleteItemsTabWarnings,intializeItemsTabWarnings} from '../../../commonActions/serverErrorAction';
import { getValidationError as ValidationError } from '../../Helper'
import { ItemDependencies } from './itemDependencies'
import { ImportShipment } from '../../../containers/importShipment'
import MerchandiseCostType from '../../../commonComponents/commonValueBuildUpTab/merchandiseCostType'
import { SUP_UNIT_COUNT} from '../../Helper/formLabel';






function MerchandiseDetails(props) {
  const dispatch = useDispatch()

  const flagForMerchLineItems = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceIndex].flag
  )
  const shipmentCurrency = useSelector(
    (state) => state.Shipment.shipmentCurrency
  )
  const lineflag = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.lineflag || false
  )

  const unitValue = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.unitValue || ''
  )



  const packageCount = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.packageCount || ''
  )
  const merchandiseId = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.merchandiseId || ''
  )

  const commodityCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.commodityCode || ''
  )
  const htsCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.htsCode || ''
  )
  const taricCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.taricCode || ''
  )
  const commercialDescription = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.commercialDescription || ''
  )
  const sku = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.sku || ''
  )
  const countryOfOrigin = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.countryOfOrigin || ''
  )
  const originProvince = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.originProvince || ''
  )
  const additionalCode1 = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.additionalCode1 || ''
  )
  const additionalCode2 = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.additionalCode2 || ''
  )

  const box37RegimeCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.box37regimeCode || ''
  )

  const tariffRegimeSuffix = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.tariffRegimeSuffix || ''
  )
  const regimeAdditionalCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.regimeAdditionalCode || ''
  )

  const exciseCode = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.exciseCode || ''
  )
  const procedure = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.procedure || ''
  )
  const procedureSuffix = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.procedureSuffix || ''
  )

  const tariffRegime = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.tariffRegime || ''
  )
  const packageType = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.packageType || ''
  )
  const unitType = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.unitType || ''
  )

  const customValue = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.customValue || ''
  )
  const unitCount = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.unitCount || ''
  )
  const unitPrice = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.unitPrice || ''
  )

  const supUnitsQuantity = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.supUnitsQuantity || ''
  )
  const supUnits = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.supUnits || ''
  )

  const convertedUnitValue = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.convertedUnitValue || ''
  )

  const grossMass = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.grossMass || ''
  )

  const netMass = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.netMass || ''
  )

  const quotaNumber = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.quotaNumber || ''
  )

  const statValue = useSelector(
    (state) =>
      state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList[props.lineItemIndex]
        ?.statValue || ''
  )
  const countryOfDispatch = useSelector((state) => state.Shipment.countryOfDispatch || '')

  const destinationCountry = useSelector((state) => state.Shipment.destinationCountry || '')

  const lineItems = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceIndex].merchandiseList
  )
  const totalLineItems = lineItems.length

  


  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  const getValidationError=(field, value, Level, onlyMandatoryCheck=false)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate)


  const box37RegimeCodes = useSelector((state) => state.DropDownValues.box37RegimeCodes)

  const specialCountryKeys = useSelector((state) => state.DropDownValues.specialCountryKeys)
  const packageTypeList = useSelector((state) => state.DropDownValues.packageTypeList)

  const unitCodes = useSelector((state) => state.DropDownValues.unitCodes)

  const box36Preference = useSelector((state) => state.DropDownValues.box36Preference)
  const box36Reduction = useSelector((state) => state.DropDownValues.box36Reduction)
  const exciseCodes = useSelector((state) => state.DropDownValues.exciseCodes)
  const originProvinceKeys = useSelector((state) => state.DropDownValues.destinationProvince)
  const { isImportShipment, serviceType } = useContext(ShipmentInfoContext)
  useEffect(() => {
    let value
    if (flagForMerchLineItems === true) {
      value = true
      dispatch(expandAllLineItem(props.invoiceIndex, value))
    }
    if (flagForMerchLineItems === false) {
      value = false
      dispatch(expandAllLineItem(props.invoiceIndex, value))
    }
  }, [flagForMerchLineItems])

  const { counter, lineItemIndex, invoiceId, invoiceIndex, isFormDisabled, translate, jobWheels } =
    props
  return (
    <ErrorBoundary>
      <div
        key={`merchandiseDetail-${merchandiseId}`}
        id={`${merchandiseId}`}
        className={'accordian-section tab-contentInvoiceM ab '}
      >
        <Message>
          <Grid
            id={`merchandiseDetail-${merchandiseId}`}
            columns={6}
            onClick={() => dispatch(expandLineItem(invoiceIndex, lineItemIndex, !lineflag))}
          >
            <MerchForm1
              isFormDisabled={isFormDisabled}
              totalLineItems={totalLineItems}
              lineNumber={counter}
              unitValue={unitValue}
              preference={tariffRegime}
              countryOfOrigin={countryOfOrigin}
              commercialDescription={commercialDescription}
              packageCount={packageCount}
              merchandiseId={merchandiseId}
              invoiceId={invoiceId}
              activeAccordianIndex={lineflag}
              invoiceItemIndex={lineItemIndex}
              commodityCode={commodityCode}
              convertedUnitValue={convertedUnitValue}
              invoiceIndex={invoiceIndex}
              translate={translate}
            />
          </Grid>
          {lineflag && (
            <>
              <Form.Group className='float-container  mg-t-15' widths='equal'>
                <Grid>
                  <Grid.Row>
                    <CommercialDescription
                      lineItemIndex={lineItemIndex}
                      commercialDescription={commercialDescription}
                      isFormDisabled={isFormDisabled}
                      invoiceIndex={invoiceIndex}
                      merchandiseId={merchandiseId}
                      invoiceId={invoiceId}
                      translate={translate}
                    />
                    <ProductTag
                      lineItemIndex={lineItemIndex}
                      invoiceIndex={invoiceIndex}
                      merchandiseId={merchandiseId}
                      invoiceId={invoiceId}
                      isFormDisabled={isFormDisabled}
                      sku={sku}
                      translate={translate}
                    />
                    <Grid.Column width='3' className='divFormFeild b-rw-0'>
                      <InputField
                        isLabel={false}
                        id={`supUnitsQuantity-${invoiceId}-${merchandiseId}`}
                        type='text'
                        boxNumber='41.1'
                        maxlength='9'
                        label={translate(SUP_UNIT_COUNT, { ns: ['default', 'lineItem'] })}
                        value={supUnitsQuantity}
                        errors={getValidationError(
                          'supUnitsQuantity',
                          supUnitsQuantity,
                          'itemsTab'
                        )}
                        className={'field-bg'}
                        clearInput={false}
                        disabled={isFormDisabled}
                        onChange={(value) => {
                          dispatch(
                            updateLineItemFeild(invoiceId, merchandiseId, {
                              supUnitsQuantity: value,
                            })
                          )
                        }}
                        onBlur={(value) => {
                          dispatch(saveLineItemFeild(merchandiseId, 'supUnitsQuantity', invoiceId))
                          let err = getValidationError(
                            'supUnitsQuantity',
                            supUnitsQuantity,
                            'itemsTab'
                          )
                          err.length
                            ? addErrors(
                                'itemsTab',
                                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` +
                                  ' :: ' +
                                  err[0],
                                `supUnitsQuantity-${merchandiseId}`
                              )
                            : deleteErrors('itemsTab', '', `supUnitsQuantity-${merchandiseId}`)
                        }}
                      />
                    </Grid.Column>
                    <Grid.Column width={'3'} className={`divFormFeild b-trr-5`}>
                      <DropDown
                        isLabel={false}
                        id={`supUnits-${invoiceId}-${merchandiseId}`}
                        type='text'
                        boxNumber='41.2'
                        box37RegimeCodes
                        label={translate('SUP_UNITS', { ns: ['default', 'lineItem'] })}
                        mandatory={false}
                        value={supUnits}
                        errors={getValidationError('supUnits', supUnits, 'itemsTab', true)}
                        className={'field-bg dropdown100'}
                        clearInput={false}
                        data={unitCodes}
                        disabled={isFormDisabled}
                        direction={'left'}
                        clearable
                        onChange={(value) => {
                          dispatch(
                            updateLineItemFeild(invoiceId, merchandiseId, {
                              supUnits: value?.trim(),
                            })
                          )
                          dispatch(saveLineItemFeild(merchandiseId, 'supUnits', invoiceId))

                          let err = getValidationError('supUnits', supUnits, 'itemsTab', true)
                          err.length
                            ? addErrors(
                                'itemsTab',
                                `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` +
                                  ' :: ' +
                                  err[0],
                                `supUnits-${merchandiseId}`
                              )
                            : deleteErrors('itemsTab', '', `supUnits-${merchandiseId}`)
                        }}
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <MerchForm2
                    lineItemIndex={lineItemIndex}
                    invoiceId={invoiceId}
                    commodityCode={commodityCode}
                    countryOfOrigin={countryOfOrigin}
                    countryOfDispatch={countryOfDispatch}
                    destinationCountry={destinationCountry}
                    box36Preference={box36Preference}
                    isFormDisabled={isFormDisabled}
                    invoiceIndex={invoiceIndex}
                    additionalCode1={additionalCode1}
                    additionalCode2={additionalCode2}
                    supUnitsQuantity={supUnitsQuantity}
                    procedure={procedure}
                    tariffRegime={tariffRegime}
                    tariffRegimeSuffix={tariffRegimeSuffix}
                    translate={translate}
                    specialCountryKeys={specialCountryKeys}
                    exciseCodes={exciseCodes}
                    customValue={customValue}
                    unitCount={unitCount}
                    unitType={unitType}
                    exciseCode={exciseCode}
                    box36Reduction={box36Reduction}
                    isImportShipment={isImportShipment}
                    serviceType={serviceType}
                    htsCode={htsCode}
                    taricCode={taricCode}
                    merchandiseId={merchandiseId}
                    originProvince={originProvince}
                    originProvinceKeys={originProvinceKeys}
                    statValue={statValue}
                  />

                  <MerchForm4
                    lineItemIndex={lineItemIndex}
                    isFormDisabled={isFormDisabled}
                    packageType={packageType}
                    invoiceIndex={invoiceIndex}
                    merchandiseId={merchandiseId}
                    invoiceId={invoiceId}
                    packageTypeList={packageTypeList}
                    packageCount={packageCount}
                    procedure={procedure}
                    translate={translate}
                    regimeAdditionalCode={regimeAdditionalCode}
                    procedureSuffix={procedureSuffix}
                  />

                  <MerchForm3
                    lineItemIndex={lineItemIndex}
                    isFormDisabled={isFormDisabled}
                    invoiceIndex={invoiceIndex}
                    merchandiseId={merchandiseId}
                    unitValue={unitValue}
                    unitCount={unitCount}
                    unitPrice={unitPrice}
                    unitType={unitType}
                    packageTypeList={packageTypeList}
                    translate={translate}
                    invoiceId={invoiceId}
                    shipmentCurrency={shipmentCurrency}
                  />

                  <MerchForm5
                    lineItemIndex={lineItemIndex}
                    grossMass={grossMass}
                    netMass={netMass}
                    statValue={statValue}
                    quotaNumber={quotaNumber}
                    isFormDisabled={isFormDisabled}
                    invoiceIndex={invoiceIndex}
                    counter={counter}
                    customValue={customValue}
                    isImportShipment={isImportShipment}
                    convertedUnitValue={convertedUnitValue}
                    unitValue={unitValue}
                    translate={translate}
                    invoiceId={invoiceId}
                    merchandiseId={merchandiseId}
                  />
                  <Container
                    merchandiseId={merchandiseId}
                    lineItemIndex={lineItemIndex}
                    isFormDisabled={isFormDisabled}
                    invoiceIndex={invoiceIndex}
                    translate={translate}
                    invoiceId={invoiceId}
                  />
                </Grid>
              </Form.Group>
              <MerchandiseCostType
                translate={translate}
                invoiceId={invoiceId}
                isFormDisabled={true}
                merchandiseId={merchandiseId}
              />

              <ItemDependencies translate={translate} invoiceId={invoiceId}
                isFormDisabled={true}
                merchandiseId={merchandiseId} />
              <ImportShipment>
                <MerchandiseDuty
                  merchandiseId={merchandiseId}
                  lineItemIndex={lineItemIndex}
                  isFormDisabled={isFormDisabled}
                  invoiceIndex={invoiceIndex}
                  translate={translate}
                  invoiceId={invoiceId}
                />
              </ImportShipment>

              <PreviciousDocuments
                isFormDisabled={isFormDisabled}
                translate={translate}
                merchandiseId={merchandiseId}
                lineItemIndex={lineItemIndex}
                invoiceIndex={invoiceIndex}
                invoiceId={invoiceId}
                jobWheels={jobWheels}
              />

              <SupportingDocs
                lineItemIndex={lineItemIndex}
                lineItemId={merchandiseId}
                isFormDisabled={isFormDisabled}
                merchandiseId={merchandiseId}
                invoiceIndex={invoiceIndex}
                translate={translate}
                invoiceId={invoiceId}
                jobWheels={jobWheels}
              />

              <SpecialMentions
                lineItemIndex={lineItemIndex}
                lineItemId={merchandiseId}
                isFormDisabled={isFormDisabled}
                invoiceIndex={invoiceIndex}
                translate={translate}
                invoiceId={invoiceId}
                jobWheels={jobWheels}
                merchandiseId={merchandiseId}
              />
            </>
          )}
        </Message>
      </div>
    </ErrorBoundary>
  )
}

export default React.memo(MerchandiseDetails)
